import React from 'react'
import "./SubStyle.css"

const Soft_ERP = () => {
  return (
    <section className="SubServices">
     <h1 className="SubServices-title">Our ERP System</h1>
      <p className="SubServices-pera">Bring all your business operations together in one integrated platform. Our ERP System helps manage key functions including staffing, compliance, finance, reporting, and performance monitoring, providing real-time insights and improved operational efficiency.</p>
         <div className="btn-container">
        <button className="SubServices-btn">
       <a>Let's get started</a>
      </button>
     </div>
    </section>
  )
}

export default Soft_ERP
